import { render, staticRenderFns } from "./StockProductFormer.vue?vue&type=template&id=1927f82a&"
import script from "./StockProductFormer.vue?vue&type=script&lang=js&"
export * from "./StockProductFormer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports